import "../../index48.css";
import { jsxs as w, jsx as a } from "react/jsx-runtime";
import _ from "react";
import { a as O } from "../../type-BFTbooL7.js";
import { _ as u } from "../../cs-piwRuCFZ.js";
import A from "../InputError/index.js";
import D from "../InputLabel/index.js";
import E from "../RawList/index.js";
import F from "./Radio/index.js";
const z = "_radio-input_17cft_1", B = "_radio-list-container_17cft_6", G = "_disabled_17cft_13", J = "_input-hint_17cft_18", s = {
  radioInput: z,
  radioListContainer: B,
  disabled: G,
  inputHint: J
};
function M(i) {
  return !!i.clearable;
}
function K(i) {
  const l = M(i), {
    className: h,
    name: r,
    options: N,
    value: n,
    keySelector: v,
    labelSelector: p,
    descriptionSelector: d,
    label: P,
    labelContainerClassName: R,
    hint: f,
    hintContainerClassName: I,
    listContainerClassName: k,
    error: L,
    renderer: q = F,
    rendererParams: c,
    disabled: t,
    readOnly: o,
    required: x,
    onChange: b,
    withAsterisk: H
  } = i, C = _.useCallback((e) => {
    o || (l && i.onChange(e === n ? void 0 : e, r), !l && O(e) && b(e, r));
  }, [
    n,
    i,
    b,
    l,
    o,
    r
  ]), S = _.useCallback((e, m) => {
    const j = {
      inputName: r,
      label: p(m),
      description: d ? d(m) : void 0,
      name: e,
      onClick: C,
      value: e === n,
      disabled: t,
      readOnly: o
    };
    return {
      ...c ? c(m) : void 0,
      ...j
    };
  }, [
    r,
    p,
    n,
    C,
    c,
    t,
    o,
    d
  ]), g = H ?? x;
  return /* @__PURE__ */ w(
    "div",
    {
      className: u(
        s.radioInput,
        t && s.disabled,
        h
      ),
      children: [
        /* @__PURE__ */ a(
          D,
          {
            className: R,
            disabled: t,
            required: g,
            children: P
          }
        ),
        /* @__PURE__ */ a("div", { className: u(s.radioListContainer, k), children: /* @__PURE__ */ a(
          E,
          {
            data: N,
            rendererParams: S,
            renderer: q,
            keySelector: v
          }
        ) }),
        f && /* @__PURE__ */ a("div", { className: u(s.inputHint, I), children: f }),
        /* @__PURE__ */ a(A, { children: L })
      ]
    }
  );
}
export {
  K as default
};
